import { CategoryInterface } from '../../../services/exports/Interfaces';
import classnames from 'classnames';

interface Props {
  key: string;
  itemId?: string;
  category?: CategoryInterface;
  focusedCategoryId?: number;
  onClick: (id?: number) => void;
}

export default function Card(props: Props) {
  const { category, focusedCategoryId, onClick } = props;
  const active = focusedCategoryId === category?.id;

  const labelContainer = classnames(
    'cursor-pointer relative px-sm h-8 ml-[1px] mr-2xs rounded flex justify-center items-center',
    { 'border border-brand-primary rounded-[37px]': active },
  );
  const titleStyle = classnames(
    'relative whitespace-nowrap text-sm lg:hover:text-brand-primary select-none uppercase',
    active && 'text-brand-primary',
    !active && 'text-brand-text-secondary',
  );

  return (
    <div className={labelContainer} onClick={() => onClick(category?.id)} key={category?.id}>
      <p className={titleStyle}>{category?.name}</p>
    </div>
  );
}
